import { useCallback } from 'react';
import { ENV_CONFIG_KEYS } from '../helpers/envConsts';
import useDataApi from './useDataApi';
import { useEnvConfig } from '../contexts/env';
import { useProject } from '../contexts/project';

const getUrl = (baseUrl, project) => {
  if (!baseUrl || !project || !project.id) {
    return null;
  }
  return `${baseUrl}/projects/${project.id}/user-settings/me`;
};

const useGetNotificationUserSettingsApi = () => {
  const project = useProject();
  const baseUrl = useEnvConfig(ENV_CONFIG_KEYS.NOTIFICATIONS_SERVICE);
  const url = getUrl(baseUrl, project);

  const { isLoading, error, data, doFetch } = useDataApi();

  const fetchSettings = useCallback(() => {
    doFetch(`${url}?include=inherit`);
  }, [url, doFetch]);

  return { isLoading, error, data, fetchSettings };
};

const useUpdateNotificationUserSettingsApi = () => {
  const project = useProject();
  const baseUrl = useEnvConfig(ENV_CONFIG_KEYS.NOTIFICATIONS_SERVICE);

  const url = getUrl(baseUrl, project);

  const { isLoading, error, data, doFetch } = useDataApi();

  const doUpdate = useCallback(
    options => {
      doFetch({ url, method: 'PUT', ...options });
    },
    [url, doFetch]
  );

  return { isLoading, error, data, doUpdate };
};

export { useGetNotificationUserSettingsApi, useUpdateNotificationUserSettingsApi };
